import SearchAutoCompleteConfigurationComponent from './Components/SearchAutoCompleteConfigurationComponent';
import { IMultiTurnThreadHistory } from '../../ThreadHistory.interface';
import {
  InteractionStepType,
  InteractionStepConfig,
  StepParamsForType,
  IndexedInteractionStepResponse,
  StepParamsForTypeWithStage,
} from '@scale/shared/types/chat';

import { SearchResponseJsonSchema } from '@scale/shared/types/chat/response';
import StepDescriptor from '../stepDescriptor/StepDescriptor';
import SearchAutocompleteViewComponent from './Components/SearchAutocompleteViewComponent';
import SearchAutocompletePinnedViewComponent from './Components/SearchAutocompletePinnedViewComponent';
import { schema } from './validation';
import { registerStepDescriptor } from '../stepDescriptor/stepDescriptorContainer';
import { CandidateState } from '@scale/shared/types/chat-completion';
import { ReviewLevel } from '@scale/shared-types';

export class SearchAutoCompleteDescriptor extends StepDescriptor<InteractionStepType.SearchAutoComplete> {
  type = InteractionStepType.SearchAutoComplete;
  title = InteractionStepConfig[InteractionStepType.SearchAutoComplete].title;
  description = InteractionStepConfig[InteractionStepType.SearchAutoComplete].description;

  validationSchema = schema;

  ViewComponent = SearchAutocompleteViewComponent;
  PinnedViewComponent = SearchAutocompletePinnedViewComponent;
  ConfigurationComponent = SearchAutoCompleteConfigurationComponent;

  isResponseValid(
    _response: IndexedInteractionStepResponse,
    _stepParams: StepParamsForTypeWithStage<InteractionStepType.SearchAutoComplete>,
    _history: IMultiTurnThreadHistory,
    _reviewLevel?: ReviewLevel,
  ) {
    return { canSubmit: true, submitTooltip: '' };
  }

  getResponseTemplatePaths(
    _stepParams: StepParamsForType<InteractionStepType.SearchAutoComplete>,
    _history: IMultiTurnThreadHistory,
  ) {
    return [
      {
        path: `context.candidates[0].message.content`,
        label: `Model Response`,
      },
      {
        path: 'context.searchHistory',
        label: 'References',
        expectsArray: true,
        expectedSchema: SearchResponseJsonSchema,
      },
      {
        path: 'context.additionalReferences',
        label: 'Additional References',
        expectsArray: true,
        expectedSchema: SearchResponseJsonSchema,
      },
    ];
  }

  generateEmptyResponse(
    stepParams: StepParamsForType<InteractionStepType.SearchAutoComplete>,
    history: IMultiTurnThreadHistory,
  ) {
    const { params } = stepParams;
    const chatPrompt = history.getMostRecentPrompt();
    return {
      type: InteractionStepType.SearchAutoComplete,
      context: {
        prompt: chatPrompt,
        candidates: [
          {
            index: 0,
            state: CandidateState.Completed,
            message: {
              role: 'assistant' as const,
              content: '',
            },
            sourceId: params.chat_models[0]?.id ?? 'sourceId',
          },
        ],
        searchHistory: [],
        additionalReferences: [],
      },
      output: '',
    };
  }
}

registerStepDescriptor({
  type: InteractionStepType.SearchAutoComplete,
  descriptor: new SearchAutoCompleteDescriptor(),
});
